import { api } from "@/lib/api";

export const LEGAL_TEXT_TYPES = [
  "Code Pénal",
  "Loi Anticorruption",
  "CNUCC / Mérida",
  "Loi Organique des Finances Publiques",
  "Autre",
];

export const GRAVITY_META = {
  1: {
    label: "Niveau 1 — Patrimonial",
    color: "green",
    badgeClass:
      "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/50 dark:text-emerald-200 dark:border-emerald-800",
    desc: "< 30 jours de vie — Sanctions patrimoniales",
  },
  2: {
    label: "Niveau 2 — Privation de liberté",
    color: "orange",
    badgeClass:
      "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/50 dark:text-amber-200 dark:border-amber-800",
    desc: "30 jours – 1 an de vie — Privation de liberté probable",
  },
  3: {
    label: "Niveau 3 — Assimilée crime",
    color: "red",
    badgeClass:
      "bg-rose-100 text-rose-900 border-rose-300 dark:bg-rose-950/50 dark:text-rose-200 dark:border-rose-800",
    desc: "> 1 an de vie — Gravité criminelle",
  },
};

export async function listLegalTexts() {
  const { data } = await api.get("/legal-texts");
  return data.data;
}

export async function uploadLegalText({
  file,
  title,
  textType,
  jurisdiction,
  onUploadProgress,
}) {
  const form = new FormData();
  form.append("file", file);
  form.append("title", title);
  form.append("text_type", textType);
  if (jurisdiction) form.append("jurisdiction", jurisdiction);
  const { data } = await api.post("/legal-texts/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    timeout: 120000,
  });
  return data.data;
}

export async function updateLegalText(textId, patch) {
  const { data } = await api.patch(`/legal-texts/${textId}`, patch);
  return data.data;
}

export async function deleteLegalText(textId) {
  const { data } = await api.delete(`/legal-texts/${textId}`);
  return data;
}

export async function runLegalAnalysis(analysisId, { legalTextIds, force = false }) {
  const { data } = await api.post(
    `/analyses/${analysisId}/legal`,
    { legal_text_ids: legalTextIds, force },
    { timeout: 180000 }
  );
  return data;
}
